module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("Published in 2011 by Stewart, Tabori & Chang"), _c('br'), _vm._v("An imprint of ABRAMS")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Copyright © 2011 Gesine Bullock-Prado"), _c('br'), _vm._v("Photographs copyright © 2011 Tina Rupp"), _c('br'), _vm._v("Props featured in this book were either the author’s own or provided courtesy of Simon Pearce.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, mechanical, electronic, photocopying, recording, or otherwise, without written permission from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data:"), _c('br'), _vm._v("Bullock-Prado, Gesine."), _c('br'), _vm._v("Sugar baby / by Gesine Bullock-Prado."), _c('br'), _vm._v("p. cm."), _c('br'), _vm._v("eISBN 978-1-4532-7688-4"), _c('br'), _vm._v("1. Cooking (Sugar) 2. Cookbooks. I. Title."), _c('br'), _vm._v("TX819.S94B85 2010"), _c('br'), _vm._v("641.6'36--dc22"), _c('br'), _vm._v("2010037768")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("ISBN: 978-1-4532-7688-4")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Editor: Natalie Kaire"), _c('br'), _vm._v("Designer: Alissa Faden"), _c('br'), _vm._v("Production Manager: Tina Cameron")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("The text of this book was primarily composed in Walbaum, Gotham, and Archer.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Stewart, Tabori & Chang books are available at special discounts when purchased in quantity for premiums and promotions as well as fundraising or educational use. Special editions can also be created to specification. For details, contact specialsales@abramsbooks.com or the address below.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pub.jpg"
    }
  }), _c('br'), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.abramsbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.abramsbooks.com")])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "noindent"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fbd538e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Copyright.vue
// module id = 66
// module chunks = 0